import gql from 'graphql-tag';

import { PhotoThumbnails } from './album';
import { AlbumRootAlbumFolderBaseDetails } from '../../../../graphql/fragments/album';

export const AccountIdentityName = gql`
  fragment AccountIdentityName on Identity {
    account_identity_name {
      id
      name
      last_name
    }
  }
`;

export const IdentityMatchingWarningFields = gql`
  fragment IdentityMatchingWarningFields on IdentityMatchingWarning {
    id
    created_at
    updated_at
    identity {
      id
      name
    }
    reported_by {
      id
      name
    }
    warning_type
    title
    notes
    blocking
    resolved
  }
`;

export const IdentityDetails = gql`
  fragment IdentityDetails on Identity {
    id
    relationship
    name
    last_name
    gender
    has_outdated_selfie
    current_photo {
      ...PhotoThumbnails
    }
    current_matching_photo {
      ...PhotoThumbnails
    }
    ...AccountIdentityName
  }
  ${PhotoThumbnails}
  ${AccountIdentityName}
`;

export const IdentityJoinedAlbums = gql`
  fragment IdentityJoinedAlbums on Identity {
    id
    album_memberships(claimed_status_filter: ALL) {
      records {
        matched_photos_extended {
          total
        }
        album {
          id
          ...AlbumRootAlbumFolderBaseDetails
        }
      }
    }
  }
  ${AlbumRootAlbumFolderBaseDetails}
`;

export const SelectedIdentityTags = gql`
  fragment SelectedIdentityTags on SelectedIdentity {
    album_folder_tags(type: UNIFORM, slice: { limit: 99 }) {
      records {
        id
        ... on IIdentityAlbumFolderTag {
          ... on IdentityUniformAlbumFolderTag {
            jersey_number
            uniform_album_folder_tag_level {
              id
              name
            }
          }
          album_folder_tag {
            ... on UniformAlbumFolderTag {
              id
              name
            }
          }
        }
      }
    }
  }
`;
